var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-edit-layout',[_c('stat-questions-form',{attrs:{"id":_vm.id,"item":_vm.item,"title":_vm.title,"parent":_vm.parent,"parentRes":_vm.parentRes,"epigraph":_vm.epigraph,"section":_vm.section}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }